<template>
    <div class="row">
        <div class="col-12">
            <label class="form-label">Ret Nedeni</label>
            <textarea v-model="value.description" class="form-control resize-none" :rows="3"></textarea>
        </div>
    </div>
</template>

<script>
export default{
    props:{
        value:Object
    }
}
</script>